import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { config } from './config';
import Login from './pages/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/styles/common.css"
import ApplyLeave from './pages/ApplyLeave';

function App() {
  return (
    <div className="">
      <Router>
        <Routes>
          <Route  path={`${config.appUrl}`} Component={Login} />
          <Route  path={`${config.appUrl}apply-leave`} Component={ApplyLeave} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
